import * as React from 'react';

import { useOnIntersection } from '../../utils';

export interface IUseModernStickyProps {
  onBottomStuck?: (isIntersecting: boolean) => void;
  onTopStuck?: (isIntersecting: boolean) => void;
}

export const useModernStickyProps = (props: IUseModernStickyProps) => {
  const { onBottomStuck, onTopStuck } = props;
  const intersectionObserverRef = React.useRef<IntersectionObserver | null>(null);
  const sentinelRef = React.useRef<HTMLDivElement | null>(null);
  const onIntersection = useOnIntersection({ onBottomStuck, onTopStuck });

  React.useEffect(() => {
    if (!sentinelRef.current) {
      return;
    }

    intersectionObserverRef.current = new IntersectionObserver(
      entries => {
        const sentinelClientRect = entries[0].boundingClientRect;
        onIntersection(sentinelClientRect);
      },
      /* NOTE: отрицательный margin, чтобы срабатывало событие пересечения до фактического пересечения
      (которое в случае 0 не происходит, т.к. элемент полностью находится в пределах видимости).
      При наличии горизонтального скроллбара не срабатывает при пересечении снизу - считаем это допущением,
      т.к. у нас не предполагается наличие контента, шире вьюпорта
       */
      { threshold: [0, 1], rootMargin: '-0.01px 0px' },
    );

    intersectionObserverRef.current.observe(sentinelRef.current);

    return () => {
      /* istanbul ignore next */
      intersectionObserverRef.current?.disconnect();
    };
  }, [onIntersection]);

  return { sentinelRef };
};
